import React, { useState, useContext } from 'react'
import Moment from 'moment'
import DatePicker, { registerLocale } from 'react-datepicker'
import pt from 'date-fns/locale/pt-BR'
import get from 'lodash/get'

import './styles.scss'

import ResultBox from '../../../../../components/ResultBox'
import Button from '../../../../../components/Button'

import contractContext from '../../../../../store/contexts/contractContext'
import CONTRACT_ACTIONS from '../../../../../store/actions/contractActions'

import 'react-datepicker/dist/react-datepicker.css'
import { useCommonStyles } from 'styles/globalStyles'

registerLocale('pt-BR', pt)

export default function PaydaySelect() {
  const commonClasses = useCommonStyles()
  const context = useContext(contractContext)
  const payday = get(context, 'proposition.details.payday')

  const initialState = get(context, 'proposition.details.displayDate') || Moment().toDate()

  const [calendarDate, setCalendarDate] = useState(initialState)
  const [displayData, setDisplayData] = useState(
    !!payday ? Moment(payday).format('DD/MM/YYYY') : Moment().format('DD/MM/YYYY'),
  )

  const handleContinue = () => {
    const { propositionDispatch } = context.proposition

    propositionDispatch({
      type: CONTRACT_ACTIONS.SET_DATE,
      value: calendarDate,
    })

    propositionDispatch({
      type: CONTRACT_ACTIONS.SET_DISPLAY_DATE,
      value: calendarDate,
    })

    context.handleStepChange('ContractDuration')
  }

  const handleSetDate = (date) => {
    setCalendarDate(date)
    setDisplayData(Moment(date).format('DD/MM/YYYY'))
  }

  return (
    <div className='MyClass'>
      <p className={commonClasses.contractSubtitle}>
        Essa vai ser a data de entrada no imóvel e data de vencimento mensal do aluguel.
      </p>
      <div className='datepicker-styler'>
        <DatePicker
          selected={calendarDate}
          onChange={handleSetDate}
          style={{ width: '100%' }}
          locale='pt-BR'
          inline
          minDate={Moment().toDate()}
        />
      </div>
      <ResultBox leftText='Data de entrada e vencimento do primeiro aluguel' rightText={displayData} />
      <div className='end-aligner'>
        <div className='button-footer'>
          <Button title='Voltar' onClick={() => context.handleStepChange('PaymentAndWarranty')} />
          <Button title='CONFIRMAR' onClick={handleContinue} />
        </div>
      </div>
    </div>
  )
}
